module.exports = __webpack_public_path__ + "img/bj46.ab61a29f.png";